<template>
  <v-container class="text-center pr-0 pl-0" fluid>
    <v-card class="elevation-10" dense>
      <v-card-title class="justify-center">Remover Conta</v-card-title>
      <v-card-text class="body-2">
        <div class="body-1">Aqui você pode remover sua conta, apagando todos os dados.</div>

        <div class="mt-10 mb-10 body-1">É importante saber que este processo é irreversível. 
          Seus dados serão apagados do nosso banco de dados e dos nossos sistemas.</div>

        <v-checkbox class="pb-0" label="Estou ciente de que é irreversível" v-model="ciente"></v-checkbox>  
        <v-checkbox class="mt-n3" label="Concordo e quero remover minha conta" v-model="concordo"></v-checkbox>  
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color=""  class="mb-2" width="100%" @click="deleteAccount"
          outlined darkv :disabled="!ciente || !concordo">
          Apagar Conta
          <v-icon right dark>mdi-trash-can</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>

//import axios from 'axios';
import HOST from '../ws'
import SnackBar from "../snackbar";


export default {
  props: {
    source: String
  },

  beforeMount () {

    //this.reloadPlanoList();
  },

  data: () => ({
    
    items : null,

    ciente : false,
    concordo : false,
    SnackBar,
  }),

  methods : {

    deleteAccount(){

      this.$store.commit("setLoader", true);
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
      .post(HOST.HOST + '/user/deleteaccount', {}, config)
      .then(response => {
        console.log('conta deletada : ' + response.status);
        this.$store.commit("setLoader", false);
        this.$store.commit("logout");
        this.$router.push("/");
        this.snackText = 'Conta deletada';
        this.snackbar = true;
      })
      .catch((error) => {
        this.$store.commit("setLoader", false);
         console.log(error.message);
         this.$store.commit('logout');
         this.$router.push("/");
      });
    }
  }
};
</script>